import { firestoreDb } from './firebase';
import {
    collection,
    query,
    orderBy,
    onSnapshot,
    deleteDoc,
    updateDoc,
    serverTimestamp,
    doc,
    where,
    getDocs,
} from 'firebase/firestore';

class FirebaseConsumer {
    constructor(convention) {
        // console.log('sessionId:', sessionId, typeof sessionId);  // should be string
        const cmdsCol = collection(firestoreDb, 'broadcasts', 'all', 'commands');
        const q = query(
            cmdsCol,
            where('payload.convention', '==', convention),
            orderBy('createdAt'),
        );
        this.unsubscribe = onSnapshot(q, snap => {
            snap.docChanges().forEach(change => {
                if (change.type === 'added') {
                    const { command, payload, createdAt } = change.doc.data();
                    const timestamp = createdAt ? createdAt.toDate() : new Date();
                    this.handleCommand(command, payload, timestamp);
                    // deleteDoc(doc(cmdsCol, change.doc.id));
                    // mark it as processed instead of deleting
                    // updateDoc(
                    //     doc(firestoreDb, 'broadcasts', 'all', 'commands', change.doc.id),
                    //     { processedAt: serverTimestamp() }
                    // );
                }
            });
        });
        this.commands = {};
        this.commandsCol = collection(firestoreDb, 'broadcasts', 'all', 'commands');
    }

    handleCommand(command, payload, timestamp) {
        // console.log('Received command:', command, payload, timestamp);
        if (this.commands[command]) {
            this.commands[command](payload, timestamp);
        } else {
            console.warn(`No handler for command: ${command}`);
        }
    }

    // one-off fetch
    async getCommandsByConvention(convention) {
        const commandsQuery = query(
            this.commandsCol,
            where('payload.convention', '==', convention),
            orderBy('createdAt', 'desc'),
        );
        const snap = await getDocs(commandsQuery);
        return snap.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    }

    tearDown() {
        this.unsubscribe();
    }

    setCommand(command, action) {
        this.commands[command] = action;
    }
}

export default FirebaseConsumer;

/*
import {
    onSnapshot,
    collection,
    doc,
    getDoc,
    setDoc,
    serverTimestamp
} from 'firebase/firestore';

const userId = auth.currentUser.uid;
const userProcessedCol = collection(
    firestoreDb,
    'users',
    userId,
    'processedCommands'
);

onSnapshot(
    collection(firestoreDb, 'broadcasts', 'all', 'commands'),
    snap => {
        snap.docChanges().forEach(async change => {
            if (change.type === 'added') {
                const cmdId = change.doc.id;
                const processedRef = doc(
                    firestoreDb,
                    'users',
                    userId,
                    'processedCommands',
                    cmdId
                );

                // only handle if this user hasn’t already
                const processedSnap = await getDoc(processedRef);
                if (!processedSnap.exists()) {
                    await handleCommand(change.doc.data());

                    // mark it processed for this user
                    await setDoc(processedRef, {
                        processedAt: serverTimestamp()
                    });
                }
            }
        });
    }
);


*/